import { inspections } from "../features/inspections/Inspections";
interface Field {
    title: string;
    name: keyof inspections;
    type: string;
    width: number;
    height?: number;
    isRequired: boolean;
    options?: string[];
}

export const Inspectionfields: Field[] = [
    {
        title: "Ins ID",
        name: "inspectionno",
        type: "text",
        width: 450,
        height: 70,
        isRequired: false,
    },
    {
        title: "Project Name",
        name: "projectname",
        type: "dropDown",
        width: 450,
        isRequired: false,
        height: 70,
        options: [],
    },
    {
        title: "Title",
        name: "title",
        type: "text",
        width: 450,
        height: 70,
        isRequired: false,
    },
    {
        title: "Inspected By",
        name: "assignedto",
        type: "dropDown",
        width: 450,
        height: 70,
        isRequired: false,
        options: [],
    },
    {
        title: "Type",
        name: "type",
        type: "text",
        width: 450,
        height: 70,
        isRequired: false,
    },
    {
        title: "Inspected On",
        name: "createddate",
        type: "date",
        height: 70,
        width: 450,
        isRequired: false,
    },
    {
        title: "Agency",
        name: "agency",
        type: "text",
        width: 450,
        height: 70,
        isRequired: false,
    },
    
    {
        title: " Remarks",
        name: "remarks",
        type: "textArea",
        width: 450,
        height: 5,
        isRequired: false,
    },
    {
        title: "Status",
        name: "status",
        type: "dropDown",
        width: 450,
        isRequired: false,
        options: ["Pending", "In progress", "Completed"],
    },
    {
        title: "Signature",
        name: "signature",
        type: "textArea",
        width: 450,
        height: 75,
        isRequired: false,
    },
    {
        title: "Attachments",
        name: "attachments",
        type: "dropzone",
        width: 450,
        height: 100,
        isRequired: false,
    },
];